import { NetworkError } from "../models";
import { API } from "@aws-amplify/api";
import { Auth } from "@aws-amplify/auth";
import { Storage } from "@aws-amplify/storage";

let _navigator;
Storage.configure({ level: "public" });

const Config = {
  API_NAME: "dev-netlise-app-api",
  API_PAYMENT: "payment-apis-dev",
  API_REPORTS: "netlise-report-api-dev",
  API_NETLISE_V2: "dev-netlise-api-v2",
  // API_SALON_LAMBDA_NAME: "dev-netlise-api-v2",
  API_ADMIN_DASHBOARD: "dev-admin-dashboard-api",
  API_POS_LAMBDA: "dev-netlise-pos-lambda-api",
  API_DASHBOARD_API: "dev-nl-dashboard-api",
};

export default class Repository {
  constructor() {
    this.API = API;
    this.Storage = Storage;
    this.API_NAME = Config.API_NAME;
    this.API_PAYMENT = Config.API_PAYMENT;
    this.API_REPORTS = Config.API_REPORTS;
    this.API_NETLISE_V2 = Config.API_NETLISE_V2;
    this.API_POS_LAMBDA = Config.API_POS_LAMBDA;
    this.API_ADMIN_DASHBOARD = Config.API_ADMIN_DASHBOARD;
    this.API_DASHBOARD_API = Config.API_DASHBOARD_API;
  }

  buildMessage(body) {
    return {
      headers: {},
      body,
      response: true,
    };
  }

  async api(method = "get", apiName, path, message) {
    let token = null;
    try {
      token = (await Auth.currentSession()).getIdToken().getJwtToken();
    } catch (e) {
      console.warn("Not authorized");
    }
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return this.API[method](apiName, path, { ...message, headers }).catch(
      (error) => {
        console.warn("error is : ", error);
        // throw error;
        const code = error.code || NetworkError.NETWORK_ERROR_CODE;
        const errorMessage =
          error.message || NetworkError.NETWORK_ERROR_MESSAGE;
        //throw new NetworkError(code, { errorMessage, apiName, path, message, method }, error);
        return null;
        // return Promise.reject(new NetworkError('code', 'message', error));
      }
    );
  }

  apiPost({ apiName = this.API_NAME, path, message }) {
    return this.api("post", apiName, path, message);
  }

  apiPut({ apiName = this.API_NAME, path, message }) {
    return this.api("put", apiName, path, message);
  }

  apiDelete({ apiName = this.API_NAME, path, message }) {
    return this.api("del", apiName, path, message);
  }

  apiGet({ apiName = this.API_NAME, path, message = null }) {
    return this.api("get", apiName, path, message);
  }

  uploadImage = async (file, fileName, bucket) => {
    try {
      const config = {
        contentType: file.type,
      }
      if (bucket) {
        config.bucket = bucket;
      }
      const result = await Storage.put(fileName, file, config);
      return result;
    } catch (error) {
      return { error };
    }
  };
}

const setTopLevelNavigator = (navigatorRef) => {
  _navigator = navigatorRef;
};

// add other navigation functions that you need and export them

export { setTopLevelNavigator };
